// CRA imports
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
// lib, redux imports and others
import { RouterProvider } from "react-router-dom";
import appStore from "./configs/appStore";
import { Provider } from "react-redux";
import appRouter from "./routes/routing";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { pdfjs } from "react-pdf";

const publicUrl = (process.env.PUBLIC_URL || "").replace(/\/$/, "");
pdfjs.GlobalWorkerOptions.workerSrc = `${publicUrl}/pdf.worker.min.js`;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <GoogleOAuthProvider
    clientId={`${process.env.REACT_APP_RANK_PLUS_GOOGLE_OAUTH_CLIENT_ID}`}
  >
    <Provider store={appStore}>
      <RouterProvider router={appRouter} />
    </Provider>
  </GoogleOAuthProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
